/* eslint max-len: off */
// TODO: Need translation!
// zh-CN
export default {
  form_entry_page: {
    section3: {
      fields: {
        agree: '本人同意所提供的资料可按照本人已阅读、理解及同意之<u>收集个人资料声明</u>及有关活动的<u>条款及细则</u>而持有及使用。',
        agree_guests: '請確保你的同行友人已同意你可使用他/她的個人資料。CHANEL只會使用你的友人的資料作活動登記，並不會用作其他用途。',
      },
    },
    modals: {
      terms_and_conditions: {
        body: `
        <b>条款及细则：</b><br />
        - 每个入场截止时间为该时段完结前15分钟<br />
        - 人流挤迫时请耐心排队等候<br />
        - 如遇8号台风信号或黑色暴雨警告，受影响场次将会被取消<br />
        <br />
        <b>预约</b><br />
        - 免费预约，但不能转售或转让他人。<br />
        - 因应各时段的预约情况，每人每次可以预约一个时段。成功预约者将收到一个附有二维码的确认短讯。<br />
        - 预约只适用于确认短讯中的二维码连结上注明的时段 （假如预约成功）。<br />
        - CHANEL保留取消LES EAUX DE CHANEL或更改活动内容（如时间、地点）而不作事前通知的权利。阁下同意并承认在LES EAUX DE CHANEL取消或更改的情况下，CHANEL将不会承担任何费用，开支，赔偿或罚款。<br />
        - 阁下必须向CHANEL职员出示二维码方可进入LES EAUX DE CHANEL。<br />
        <br />
        <b>入场须知</b><br />
        - 场内不准吸烟、携带宠物或饮食。<br />
        - 为了确保贵宾、顾客及员工的安全及确保活动得以顺利进行及/或保障展示物品，CHANEL将会不时发出更多指引。所有在场内或附近的访客敬请遵守这些指引（ 由CHANEL不时发出或更改的所有指引）。<br />
        - 假如CHANEL合理地认为该人士是或可能违反了CHANEL发出的指引，CHANEL保留（1）禁止任何人进入场地（无论他或她是否有有效预约）;或（2）如果该人士已进入场地，要求该人士立即离开场地之权利。<br />
        `,
      },
      accept_terms: {
        body: `
        <b>收集个人资料声明：</b>阁下同意并自愿向CHANEL提供个人资料就CHANEL的产品作销售评估、为直接推广及研究而与顾客联络及资料分析之用。阁下的个人资料(即姓名，地址，电话号码及电邮地址)可能将被CHANEL用作与CHANEL时装及配饰、腕表及高级珠宝、及香水及彩妆有关的直接推广的用途，并且为作此等用途CHANEL可能会将阁下的个人资料披露或传送予全球CHANEL集团公司及向CHANEL提供与上述用途相关的管理、推广及研究服务的代理商及服务提供商，或与之共用资料。未经阁下同意，CHANEL不会使用或传送阁下的个人资料以用作直接推广的用途。通过签署本声明，阁下同意CHANEL使用或传送阁下的个人资料给以上提及的第三者以作直接推广的用途。阁下有权存取及更正阁下所提供的个人资料。如希望CHANEL从联络及邮递名单中删除阁下的名字，或希望查询有关阁下之个人资料的事宜(包括存取及更正资料)，可联络CHANEL的客户服务代表，地址为香港中环置地广场告罗士打大厦四十一楼(电邮地址： customerservice@chanel.com.hk)
        <br />
        `,
      },
    },
  },
  complete_page: {
    reservation: {
      venue_address: '国际金融中心商场第1层1060铺',
    },
    did_not_receive_sms: {
      message: '假如你在预约过程中遇到任何问题，请致电CHANEL顾客服务热线28101083',
    },
  },
};



// WEBPACK FOOTER //
// ./src/locales/zh-CN.js